import { ExternalLink, KeyRound, Send } from "lucide-react";
import PortalStatusBadge from "./PortalStatusBadge";

export default function ClientPortalAccessCard({ portalAccess, onManage, onActivate, onInvite, onOpenPortal }) {
  const summary = portalAccess?.summary || {};
  const isActive = String(summary.status || "") === "active";

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h4 className="text-sm font-semibold text-slate-900">Opdrachtgeversportaal</h4>
        <PortalStatusBadge status={summary.status || "inactive"} />
      </div>

      <div className="grid gap-2 text-sm text-slate-600">
        <p><span className="text-slate-500">Portalgebruikers:</span> {summary.portalUsersCount || 0}</p>
        <p><span className="text-slate-500">Primair contact:</span> {summary.primaryPortalContact?.naam || "Niet ingesteld"}</p>
        <p><span className="text-slate-500">Laatste activiteit:</span> {summary.lastActivityAt || "-"}</p>
        <p><span className="text-slate-500">Open opdrachten in portaal:</span> {summary.openPortalAssignments || 0}</p>
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        <button type="button" onClick={onManage} className="rounded-lg border border-slate-200 px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50">
          Portaal beheren
        </button>
        <button type="button" onClick={onActivate} className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50">
          <KeyRound size={13} /> Portaal activeren
        </button>
        <button type="button" onClick={onInvite} className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50">
          <Send size={13} /> Uitnodiging versturen
        </button>
        <button
          type="button"
          onClick={onOpenPortal}
          disabled={!isActive}
          className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-50"
        >
          <ExternalLink size={13} /> Open portaal
        </button>
      </div>
    </div>
  );
}
